import React, { useState } from 'react';
import PricingView from './PricingView';
import { functions } from '../services/firebase';
import { getStripe } from '../services/stripe';

interface PricingModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const PricingModal: React.FC<PricingModalProps> = ({ isOpen, onClose }) => {
    const [loadingPlan, setLoadingPlan] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handleSelectPlan = async (priceId: string) => {
        if (!functions) {
            setError("El servicio de pago no está disponible en este momento.");
            return;
        }
        setLoadingPlan(priceId);
        setError(null);

        try {
            const createCheckout = functions.httpsCallable('createStripeCheckout');
            const result = await createCheckout({
                priceId: priceId,
                successUrl: `${window.location.origin}?subscription_success=true`,
                cancelUrl: window.location.href,
            });
            
            const sessionId = (result.data as any).sessionId;
            if (!sessionId) {
                 throw new Error("No se pudo obtener el ID de la sesión de pago.");
            }

            const stripe = await getStripe();
            if (stripe) {
                await (stripe as any).redirectToCheckout({ sessionId });
            } else {
                 throw new Error("No se pudo cargar la librería de Stripe.");
            }

        } catch (err: any) {
            console.error("Error creating checkout session:", err);
            // The backend now sends a user-friendly message in err.details.message
            const userFriendlyError = err.details?.message ||
              "Ocurrió un error inesperado al conectar con el servicio de pagos. Por favor, inténtalo de nuevo.";
            setError(userFriendlyError);
            setLoadingPlan(null);
        }
    };

    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4"
            onClick={onClose}
        >
            <div 
                className="bg-light-surface dark:bg-surface rounded-lg shadow-xl w-full max-w-5xl border border-light-border dark:border-border flex flex-col max-h-[90vh]"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center p-6 border-b border-light-border dark:border-border flex-shrink-0">
                    <h2 className="text-2xl font-bold text-light-text-primary dark:text-text-primary">Elige tu Plan</h2>
                    <button
                        onClick={onClose}
                        className="text-light-text-secondary dark:text-text-secondary hover:text-light-text-primary dark:hover:text-text-primary transition-colors"
                        aria-label="Cerrar modal"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>
                <div className="overflow-y-auto p-8">
                    <PricingView onSelectPlan={handleSelectPlan} loadingPlan={loadingPlan} />
                     {error && <p className="mt-6 text-sm text-red-500 text-center">{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default PricingModal;